module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif(!model.info){\nadditionalClasses.push('hidden');\n}\n%>\n<div class=\"<%= additionalClasses.join(' ') %>\">\n<div class=\"title\"><%= storage.__('common:form.fieldInfo.headline') %>:</div>\n<p><%= model.info || '' %></p>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fieldDescription.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if(!model.info){
additionalClasses.push('hidden');
}

    ; __line = 6
    ; __append("\n<div class=\"")
    ; __line = 7
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<div class=\"title\">")
    ; __line = 8
    ; __append(escapeFn( storage.__('common:form.fieldInfo.headline') ))
    ; __append(":</div>\n<p>")
    ; __line = 9
    ; __append(escapeFn( model.info || '' ))
    ; __append("</p>\n</div>")
    ; __line = 10
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fieldDescription.ejs

}